import { Routes } from '@angular/router';
import { INavBar } from '../app/Components/navbar/navbar.model';
import { AboutComponent } from '../app/Pages/National/about/about.component';
import { HistoryComponent } from '../app/Pages/National/about/history/history.component';
import { PartnersComponent } from '../app/Pages/National/about/partners/partners.component';
import { StaffComponent } from '../app/Pages/National/about/staff/staff.component';
import { TourComponent } from '../app/Pages/National/about/tour/tour.component';
import { AcademicsComponent } from '../app/Pages/National/academics/academics.component';
import { AdmissionComponent } from '../app/Pages/National/academics/admission/admission.component';
import { ArLibraryComponent } from '../app/Pages/National/academics/libraries/ar-library/ar-library.component';
import { FrLibraryComponent } from '../app/Pages/National/academics/libraries/fr-library/fr-library.component';
import { KgComponent } from '../app/Pages/National/academics/stages/kg/kg.component';
import { PreparatoryComponent } from '../app/Pages/National/academics/stages/preparatory/preparatory.component';
import { PrimaryComponent } from '../app/Pages/National/academics/stages/primary/primary.component';
import { SecondaryComponent } from '../app/Pages/National/academics/stages/secondary/secondary.component';
import { ActivitiesComponent } from '../app/Pages/National/activities/activities.component';
import { ArtComponent } from '../app/Pages/National/activities/art/art.component';
import { ScoutsComponent } from '../app/Pages/National/activities/scouts/scouts.component';
import { SocialComponent } from '../app/Pages/National/activities/social/social.component';
import { SportsComponent } from '../app/Pages/National/activities/sports/sports.component';
import { TheatreComponent } from '../app/Pages/National/activities/theatre/theatre.component';
import { AlumniComponent } from '../app/Pages/National/alumni/alumni.component';
import { CareersComponent } from '../app/Pages/National/careers/careers.component';
import { HomeComponent } from '../app/Pages/National/home/home.component';
import { ArchiveComponent } from '../app/Pages/National/mediacenter/archive/archive.component';
import { MediaCenterComponent } from '../app/Pages/National/mediacenter/mediacenter.component';
import { PhotoComponent } from '../app/Pages/National/mediacenter/photo/photo.component';
import { PressComponent } from '../app/Pages/National/mediacenter/press/press.component';
import { RadioComponent } from '../app/Pages/National/mediacenter/radio/radio.component';
import { VideoComponent } from '../app/Pages/National/mediacenter/video/video.component';
import { NewsComponent } from '../app/Pages/National/news/news.component';
import { NotfoundComponent } from '../app/Pages/notfound/notfound.component';

export const nationalConfigs = {
  routes: [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    {
      path: 'academics',
      children: [
        { path: '', component: AcademicsComponent },
        {
          path: 'stages',
          children: [
            { path: 'kg', component: KgComponent },
            { path: 'primary', component: PrimaryComponent },
            { path: 'preparatory', component: PreparatoryComponent },
            { path: 'secondary', component: SecondaryComponent },
          ],
        },
        {
          path: 'libraries',
          children: [
            { path: 'frLibrary', component: FrLibraryComponent },
            { path: 'arLibrary', component: ArLibraryComponent },
          ],
        },
        { path: 'alumni', component: AlumniComponent },
      ],
    },

    { path: 'news', component: NewsComponent },

    {
      path: 'activities',
      children: [
        { path: '', component: ActivitiesComponent },
        { path: 'scouts', component: ScoutsComponent },
        { path: 'art', component: ArtComponent },
        { path: 'sports', component: SportsComponent },
        { path: 'social', component: SocialComponent },
        { path: 'theatre', component: TheatreComponent },
      ],
    },

    {
      path: 'mediacenter',
      children: [
        { path: '', component: MediaCenterComponent },
        // { path: 'photo', component: PhotoComponent },
        // { path: 'video', component: VideoComponent },
        { path: 'press', component: PressComponent },
        { path: 'radio', component: RadioComponent },
        { path: 'archive', component: ArchiveComponent },
      ],
    },
    {
      path: 'about',
      children: [
        { path: '', component: AboutComponent },
        { path: 'history', component: HistoryComponent },
        { path: 'tour', component: TourComponent },
        { path: 'staff', component: StaffComponent },
        { path: 'partners', component: PartnersComponent },
      ],
    },

    { path: 'admission', component: AdmissionComponent },

    { path: 'careers', component: CareersComponent },

    { path: '**', component: NotfoundComponent },
  ] as Routes,

  systemLogos: ['girard.jpg', 'iso_ar.png', 'iso_fr.png'],

  navbar: [
    { title: 'home', url: '/home' },
    {
      title: 'academics',
      url: '/academics',
      children: [
        {
          title: 'stages',
          url: '/academics',
          fragment: 'STAGES_SECTION',
        },
        {
          title: 'libraries',
          url: '/academics',
          fragment: 'LIBRARY_SECTION',
        },
        {
          title: 'alumni',
          url: '/academics',
          fragment: 'ALUMNI_SECTION',
        },
      ],
    },
    { title: 'news', url: '/news' },
    {
      title: 'activities',
      url: '/activities',
      children: [
        {
          title: 'scouts_mej',
          url: '/activities/scouts',
        },
        {
          title: 'art',
          url: '/activities/art',
        },
        {
          title: 'sport',
          url: '/activities/sports',
        },
        {
          title: 'social',
          url: '/activities/social',
        },
        {
          title: 'theatre',
          url: '/activities/theatre',
        },
      ],
    },
    {
      title: 'media_center',
      url: '/mediacenter',
      children: [
        // {
        //   title: 'photo_gallery',
        //   url: '/mediacenter/photo',
        // },
        // {
        //   title: 'video_gallery',
        //   url: '/mediacenter/video',
        // },
        {
          title: 'press_release',
          url: '/mediacenter/press',
        },
        {
          title: 'radio',
          url: '/mediacenter/radio',
        },
        {
          title: 'archive',
          url: '/mediacenter/archive',
        },
      ],
    },
    {
      title: 'about_us',
      url: '/about',
      children: [
        {
          title: 'history',
          url: '/about/history',
        },
        {
          title: 'school_tour',
          url: '/about/tour',
        },
        {
          title: 'staff',
          url: '/about/staff',
        },
        {
          title: 'partners',
          url: '/about/partners',
        },
      ],
    },
    { title: 'admission', url: '/admission' },
    { title: 'careers', url: '/careers' },
  ] as INavBar[],
};
